import { useQuery } from '@tanstack/react-query';
import { http } from '@/lib/http';
import type { ISystemHealth } from './system-status';

/**
 * BFF /health, refreshed each minute for the sidebar footer.
 *
 * A deliberate exception to "WebSockets, never polling": that rule keeps DOMAIN
 * data honest, while this is the infrastructure heartbeat itself — when the BFF
 * (and with it the socket) is gone, a WS-carried health signal is exactly what
 * you no longer have. One tiny public GET per operator per minute.
 */
export function useSystemStatus() {
  return useQuery<ISystemHealth>({
    queryKey: ['system-status'],
    queryFn: async () => http.get('health').json<ISystemHealth>(),
    refetchInterval: 60_000,
    staleTime: 55_000,
    // ky already retries transient failures; a red dot NOW beats one in 3 tries.
    retry: false,
  });
}
